import { XMarkIcon } from '@heroicons/react/24/outline';
export const CloseIcon = XMarkIcon;
